<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <VehicleEvolution
          v-if="vehicleEvolution && vehicleEvolution.rows && vehicleEvolution.rows.length"
          :evolutionData="vehicleEvolution"
        />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import VehicleEvolution from '@/components/frotix-management/vehicle-evolution/VehicleEvolution.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'VehicleEvolutions',

  components: {
    PageTitle,
    PageRowWrapper,
    VehicleEvolution
  },

  computed: {
    ...mapState({
      vehicleEvolution: state => state.vehicleevolution.all
    })
  },

  methods: {
    ...mapActions('vehicleevolution', ['fetchVehicleEvolution', 'cleanState'])
  },

  mounted () {
    this.fetchVehicleEvolution()
  },

  destroyed () {
    this.cleanState()
  },
}
</script>
